import React from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

const styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none',
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px',
        }
    },
};

class TextEditor extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.originalText,
        };

        this.toggleDialog = this.toggleDialog.bind(this);
        this.changeTextLetterText = this.changeTextLetterText.bind(this);
        this.returnOriginalText = this.returnOriginalText.bind(this);
        this.updateGazetters = this.updateGazetters.bind(this);
    }

    returnOriginalText() {
        this.setState({
            textLetter: this.props.originalText,
        });
    }

    async updateGazetters() {
        const { textLetter } = this.state;

        if(textLetter) {
            this.toggleDialog();
        
            this.props.removeAnnotations();
            this.props.removeGazetters();
            await this.props.getLetterData(textLetter);
            this.props.updatePostGazetters(textLetter);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            textLetter: nextProps.textLetter,
            originalText: nextProps.originalText,
        });
    }

    changeTextLetterText(e) {
        this.setState({
            textLetter: e.target.value,
        });
    }

    toggleDialog() {
        const { open } = this.state;
        this.setState({
            open: !open,
        });
    }

    render() {
        const { textLetter, open } = this.state;
        const actions = [
            <FlatButton
                label='RE-ANNOTATE'
                primary
                onClick={this.updateGazetters}
            />,
            <FlatButton
                label='RETURN ORIGINAL TEXT'
                primary
                onClick={this.returnOriginalText}
            />,
            <FlatButton
                label='CLOSE'
                primary
                onClick={this.toggleDialog}
            />,
        ];
        return (
            <div className='btn'>
                <RaisedButton
                    label='Editor'
                    labelStyle={styles.button.labelStyle}
                    style={styles.button.style}
                    buttonStyle={styles.button.buttonStyle}
                    onClick={this.toggleDialog}
                    primary
                />

                <Dialog 
                    title='Edit letter text'
                    actions={actions}
                    contentStyle={styles.dialog.contentStyle}
                    open={open}
                    modal
                >
                    <textarea 
                        style={styles.textarea.style}
                        value={textLetter}
                        onChange={this.changeTextLetterText}
                    />
                </Dialog>
            </div>
        );
    }
}

export default TextEditor;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Content/TextEditor.jsx